import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

type Props = {
  disabled: boolean;
  enableEditFeature: boolean;
};

export const useStyles = makeStyles(() => ({
  container: ({ enableEditFeature, disabled }: Props) => ({
    fontFamily: 'Poppins, sans-serif',
    padding: enableEditFeature ? '1.5rem' : '1.5rem 0',
    '&:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.brandGray.light}`,
    },
    background: disabled ? theme.palette.brandGray.lighter : 'none',
  }),

  label: {
    fontWeight: 400,
    color: theme.palette.brandGray.dark,
  },

  content: ({ disabled }: Props) => ({
    marginTop: theme.spacing(1),
    fontSize: '20px',
    fontWeight: 600,
    color: disabled ? theme.palette.text.secondary : theme.palette.text.primary,
  }),
}));
